import { Box, Heading, Stack } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { ActivityLogs } from "../../../../ActivityLogs"
import { useParams } from "../../../../router-utils"

export default function SupplierActivityLogsPage() {
	const { supplierId } = useParams("/suppliers/:supplierId")
	return (
		<>
			<Helmet>
				<title>Activity Logs | Supplier</title>
			</Helmet>
			<Box padding="6" bgColor="default" roundedBottom="md">
				<Stack gap="2">
					<Heading as="h5">Activities</Heading>
					<ActivityLogs
						subjectType="transport_service_providers"
						subjectId={Number(supplierId)}
						hideTrackingInfo
					/>
				</Stack>
			</Box>
		</>
	)
}
